module.exports = __webpack_public_path__ + "static/media/POLITICADATOSDISEX2022.4d6f487f.pdf";